/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext, useState } from 'react';
import { Card, Icon } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../locales/en-US/descriptors';
import SharedTabsWidget from '../../shared/SharedTabs/SharedTabs';
import IEnergyManagementProps from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { DataContextProvider } from '@forge/data-connector';
import { ApiContext } from '../../../context/ApiContext';
import PortfolioTotalEmissionsTabDetailsComponent from './PortfolioTotalEmissionsTab/PortfolioTotalEmissionsDetailsComponent';
import PortfolioCarbonScopeOneDetailsTabComponent from './PortfolioCarbonScopeOneTab/PortfolioCarbonScopeOneDetailsComponent';
import PortfolioCarbonScopeTwoDetailsTabComponent from './PortfolioCarbonScopeTwoTab/PortfolioCarbonScopeTwoDetailsComponent';
import '../CarbonSiteViewDetailsComponent/CarbonDetailViewDetailsTheme.scss';
import { FilterScope1Provider } from '../../../context/FilterScope1Context/FilterScope1Context';
import PortfolioCarbonAvoidanceTabComponet from './PortfolioCarbonAvoidance/PortfolioCarbonAvoidanceTabComponet';
import {
  EnergyUsageDataSourceType,
  SmartPowerSubscriptionType
} from '../../shared/Enums';

const PortfolioCarbonSiteViewDetailsComponentContent = (
  props: IEnergyManagementProps
) => {
  const { bearerToken, requestContext } = props;
  const d = descriptors.DetailedView;
  const [t] = useTranslation();

  const apiContext = useContext(ApiContext);
  const { onBacktoDashboardClick } = apiContext!;

  const onBackarrowClick = () => {
    if (onBacktoDashboardClick) {
      onBacktoDashboardClick();
    }
  };

  const {
    cemsEnableCarbonSourceSelect,
    dataSourceType,
    setDataSourceType,
    cemsIntervalEnergySourceOption
  } = apiContext;

  const displayTabs = {
    displayTabs: [
      {
        className: 'emaas-carbondetail-view-details-total-emissions',
        title: t(d.TOTALEMISSIONS),
        component: PortfolioTotalEmissionsTabDetailsComponent
      },
      {
        className: 'emaas-utility-view-details-scope-one',
        title: t(d.SCOPE1),
        component: PortfolioCarbonScopeOneDetailsTabComponent
      },
      {
        className: 'emaas-utility-view-details-scope-two',
        title: t(d.SCOPE2),
        component: PortfolioCarbonScopeTwoDetailsTabComponent
      }
    ],
    bearerToken: bearerToken,
    requestContext,
    ActiveIndex: apiContext?.ActiveIndex,
    enableConsumptionSourceSelect: cemsEnableCarbonSourceSelect,
    isCarbonSourceConsumptionSelect: true,
    dataSourceType,
    setDataSourceType,
    hideDataSourceSelectForIndices: [] as number[],
    cemsIntervalEnergySourceOption
  };

  if (
    requestContext.context.smpSubscriptionType ===
    SmartPowerSubscriptionType.PREMIUM_SUBSCRIPTION
  ) {
    displayTabs.displayTabs.push({
      className: 'emaas-carbondetail-view-details-total-emissions',
      title: t(d.CARBONAVOIDANCE),
      component: PortfolioCarbonAvoidanceTabComponet
    });
    displayTabs.hideDataSourceSelectForIndices.push(3);
  }

  return (
    <FilterScope1Provider>
      <div className="emaas-carbonview-container-kpi-card-common">
        <Card>
          <Card.Header className="emaas-carbonviewdetail-viewDetails-kpi-header-container">
            <div className="emaas-carbonviewdetail-viewDetails-kpi-card-title">
              <span className="carbonviewdetail-backButton">
                <Icon
                  root="common"
                  name="arrow-left"
                  size="medium"
                  onClick={() => onBackarrowClick()}
                />
              </span>
              {t(d.PORTFOLIOCARBONTITLE)}
            </div>
          </Card.Header>
          <Card.Content className="emaas-carbonviewdetail-viewDetails-kpi-content-container">
            <DataContextProvider config={props.connectorConfig}>
              <SharedTabsWidget {...displayTabs} />
            </DataContextProvider>
          </Card.Content>
        </Card>
      </div>
    </FilterScope1Provider>
  );
};

export default PortfolioCarbonSiteViewDetailsComponentContent;
